export const terminalStorageKey = 'selfCheckin.terminal.ip'
export const terminalPortStorageKey = 'selfCheckin.terminal.port'
export const cashChangerStorageKey = 'selfCheckin.cashChanger.serialNumber'
export const serialNumberStorageKey = 'selfCheckin.cardReader.serialNumber'
export const selfCardPCIDStorageKey = 'selfCheckin.cardReader.pcId'
export const checkinEposPrinterIdStorage = 'checkinEposPrinterId'
